module.exports = __webpack_public_path__ + "img/device_dr002_2.6e3f5422.png";